import React from 'react';

import { Outlet, useLocation } from 'react-router-dom';
import { routeDefinitions } from '../routes';

function Content() {
  const localLocation = useLocation();
  const routeParts = localLocation.pathname.split('/').filter((el) => el);
  const cleanRoute = routeParts[0] || localLocation.pathname;
  const routeDefinition =
    cleanRoute === routeDefinitions.templates.route && routeParts.length > 1
      ? routeDefinitions.template
      : routeDefinitions[cleanRoute];

  return (
    <div className="p-4 min-[1300px]:ml-64">
      <div className="p-4 rounded-lg dark:border-gray-700 mt-14">
        <h1 className="text-white text-2xl text-bold mb-5 font-bold">{routeDefinition.text}</h1>
        <hr />
        <br />
        <Outlet />
      </div>
    </div>
  );
}

export default Content;
